import { Zap } from "lucide-react";

/**
 * Small pill that surfaces "Flexible Schedule" on any appointment-bearing
 * record (lead, job, customer). Renders nothing if the flag isn't set, so
 * callers can drop it inline without conditionals.
 *
 * Visual: amber pill with a Zap icon — meant to read as "opportunity to
 * call earlier" without competing with the primary status badge.
 */
export const FlexibleScheduleBadge = ({ flexible, size = "sm", className = "" }) => {
  if (!flexible) return null;

  const sizeCls =
    size === "xs"
      ? "px-1.5 py-0.5 text-[9px] gap-0.5"
      : size === "md"
      ? "px-2.5 py-1 text-xs gap-1.5"
      : "px-2 py-0.5 text-[10px] gap-1";

  const iconSize = size === "md" ? "w-3 h-3" : "w-2.5 h-2.5";

  return (
    <span
      data-testid="flexible-schedule-badge"
      title="Customer is open to an earlier appointment if one opens up"
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider bg-amber-100 text-amber-800 border border-amber-300 ${sizeCls} ${className}`}
    >
      <Zap className={`${iconSize} fill-amber-500`} />
      Flexible
    </span>
  );
};

export default FlexibleScheduleBadge;
